<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <ThankYou></ThankYou>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import ThankYou from '@/components/blocks/ThankYou.vue'
import http from "@/api/http";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        ThankYou
    },
    mounted() {
        to_top()
        this.init()
    },
    data() {
        return {
            classes: []
        }
    },
    methods: {
        async init() {
            let { data } = await http.get('statement-of-use/step-thank-you/' + this.$route.params.key);

            this.classes = data.data.data.classes
            if (data.res) {
                if (data.data.data.status != 'C' || data.data.data.status_payment != 'Y') {
                    this.$router.push({ path: '/statement-of-use/step-owners/' + this.$route.params.key })
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
    },
    computed: {
        countElements() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].is_using_trademark) {
                    num += 2
                } else {
                    num += 1
                }
            }

            return this.classes.length ? num + 2 : 0
        }
    }
}
</script>
